// O backend responde validação (422) no formato { message, detail: [{ message_error, key }] } -
// detail[].message_error já traz o motivo específico (ex: "Inscrição federal não informada."),
// bem mais útil pro usuário que o "message" genérico ("A requisição não pode ser processada").
export default function extrairMensagemErro(error, mensagemPadrao) {
  const detalhe = error?.response?.data?.detail;
  const mensagemDetalhe = Array.isArray(detalhe) ? detalhe[0]?.message_error : null;
  return mensagemDetalhe || error?.response?.data?.message || mensagemPadrao;
}
